export const STYLE = `
.shell,.shell *{box-sizing:border-box;margin:0;padding:0}
/* This module's variables are now aliases onto the Orbit tokens in
   shared/styles/tokens.css, so the ~80 rules below inherit the system
   without each one being rewritten. --navy was already the Run button's
   fill, so it maps to ink; --accent only ever tinted hover affordances
   and the spinner, so it maps to brass. --accent2 (a second purple) was
   defined but never referenced and is gone. */
:root{
  --bg:var(--paper);--surface2:var(--surface-2);--surface3:#EAE9E5;
  --navy:var(--ink);--navy2:var(--ink-lift);--accent:var(--brass);
  --green:var(--valid);--red:var(--error);--amber:var(--warn);--blue:#93AFCF;
  --txt:var(--text);--txt2:var(--text-2);--txt3:var(--text-3);--border:var(--rule);
  --r:var(--r-md);--r2:var(--r-md);
  --editor-dark:var(--ink);--editor-gutter:var(--ink-lift);--editor-txt:#E6E9ED;
  --editor-comment:#6E7683;--editor-border:var(--ink-line);
  --sq-editor-h:280px;
}
html,body{height:100%;overflow:hidden}

.shell{display:flex;flex-direction:column;height:calc(100vh - 60px);overflow:hidden;font-family:var(--font-ui);color:var(--txt);font-size:13px;background:var(--bg)} /* 60px = OrbitModuleHeader */

/* â”€â”€ SQL EDITOR BODY â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.sq-body{display:flex;flex:1;overflow:hidden;min-height:0}

/* Sidebar */
.sq-sidebar{width:210px;min-width:180px;background:var(--surface);border-right:1px solid var(--border);display:flex;flex-direction:column;overflow:hidden;flex-shrink:0}
.sq-sidebar-hdr{padding:12px 14px 8px;font-size:10px;font-weight:700;color:var(--txt3);text-transform:uppercase;letter-spacing:.6px;display:flex;align-items:center;gap:6px;border-bottom:1px solid var(--border)}
.sq-sidebar-hdr i{font-size:13px}
.sq-tree{overflow-y:auto;flex:1;padding:6px 0}
.sq-schema-label{padding:6px 14px 4px;font-size:9px;font-weight:700;color:var(--txt3);text-transform:uppercase;letter-spacing:.5px}
.sq-schema-loading{padding:12px 14px;font-size:11px;color:var(--txt3);font-style:italic}
.sq-table-item{display:flex;align-items:center;gap:7px;padding:6px 14px;font-size:11px;font-weight:500;color:var(--txt2);cursor:pointer;transition:background .12s;border:none;background:transparent;width:100%;text-align:left;font-family:var(--font-ui)}
.sq-table-item:hover{background:var(--surface3);color:var(--txt)}
.sq-table-item i{font-size:13px;color:var(--txt3);flex-shrink:0}
.sq-table-item span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}

/* Main area */
.sq-main{flex:1;display:flex;flex-direction:column;overflow:hidden;min-width:0}

/* Toolbar */
.sq-toolbar{height:46px;background:var(--surface);border-bottom:1px solid var(--border);display:flex;align-items:center;gap:8px;padding:0 14px;flex-shrink:0}
.sq-badge{font-size:10px;font-weight:600;padding:2px 8px;border-radius:999px;letter-spacing:.05em;text-transform:uppercase;flex-shrink:0}
.sq-badge-select{background:var(--code-wash);color:var(--code)}
.sq-badge-insert{background:var(--valid-wash);color:var(--valid)}
.sq-badge-update{background:var(--brass-wash);color:var(--brass)}
.sq-badge-delete{background:#F5E4E4;color:var(--error)}
.sq-badge-with{background:var(--code-wash);color:var(--code)}
.sq-badge-other{background:var(--surface3);color:var(--txt3)}
.sq-btn{display:inline-flex;align-items:center;gap:5px;padding:6px 14px;border-radius:var(--r-sm);font-size:12px;font-weight:600;cursor:pointer;border:1px solid var(--border);background:var(--surface);color:var(--txt2);transition:border-color .15s,background .15s;font-family:var(--font-ui);white-space:nowrap}
.sq-btn:hover{background:var(--border);color:var(--txt)}
.sq-btn i{font-size:13px}
.sq-btn-run{background:var(--navy);color:#fff;border-color:var(--navy)}
.sq-btn-run:hover{background:var(--navy2)}
.sq-shortcut{font-size:10px;opacity:.6;background:rgba(255,255,255,.15);padding:1px 5px;border-radius:4px;margin-left:2px}
.sq-toolbar-sep{width:1px;height:20px;background:var(--border);flex-shrink:0;margin:0 2px}
.sq-status{flex:1;min-width:0;display:flex;align-items:center;gap:6px;font-size:11px;color:var(--txt3);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.sq-status.ok{color:var(--green)}
.sq-status.err{color:var(--red)}

/* Editor */
.sq-editor-area{display:flex;overflow:hidden;background:var(--editor-dark);min-height:100px;flex-shrink:0}
.sq-gutter{min-width:44px;background:var(--editor-gutter);border-right:1px solid var(--editor-border);padding:14px 0;overflow:hidden;user-select:none;flex-shrink:0}
.sq-gutter-line{display:block;text-align:right;padding:0 10px;line-height:1.65;font-size:12px;font-family:var(--font-mono);color:var(--editor-comment);transition:color .1s}
.sq-editor{flex:1;background:transparent;color:var(--editor-txt);font-family:var(--font-mono);font-size:13px;line-height:1.65;border:none;outline:none;resize:none;padding:14px 18px;tab-size:2;caret-color:var(--brass-lift);letter-spacing:.01em}
.sq-editor::placeholder{color:var(--editor-comment)}
.sq-editor::-webkit-scrollbar{width:6px;height:6px}
.sq-editor::-webkit-scrollbar-thumb{background:var(--editor-border);border-radius:3px}

/* Drag handle */
.sq-drag-handle{height:5px;background:var(--border);cursor:row-resize;flex-shrink:0;transition:background .15s;display:flex;align-items:center;justify-content:center}
.sq-drag-handle:hover,.sq-drag-handle.dragging{background:var(--accent)}
.sq-drag-handle::after{content:'';width:32px;height:2px;background:var(--txt3);border-radius:1px;opacity:.4}

/* Results panel */
.sq-results{flex:1;display:flex;flex-direction:column;overflow:hidden;min-height:0}
.sq-results-hdr{height:36px;background:var(--surface);border-top:1px solid var(--border);border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;padding:0 14px;flex-shrink:0}
.sq-results-info{font-size:11px;font-weight:600;color:var(--txt2);display:flex;align-items:center;gap:6px}
.sq-results-info i{font-size:13px}
.sq-results-actions{display:flex;gap:6px}
.sq-btn-sm{padding:4px 10px;font-size:11px}
.sq-results-body{flex:1;overflow:auto;background:var(--surface)}
.sq-results-body::-webkit-scrollbar{width:6px;height:6px}
.sq-results-body::-webkit-scrollbar-thumb{background:var(--border);border-radius:3px}

/* Results table */
.sq-table{width:100%;border-collapse:collapse;font-size:12px;font-family:var(--font-mono)}
.sq-table thead{position:sticky;top:0;z-index:10}
.sq-table th{background:var(--surface-2);padding:8px 12px;text-align:left;font-weight:600;color:var(--txt3);border-bottom:1px solid var(--border);border-right:1px solid var(--rule-soft);white-space:nowrap;font-size:10px;letter-spacing:.09em;text-transform:uppercase;font-family:var(--font-ui)}
.sq-table th:last-child{border-right:none}
.sq-table td{padding:7px 12px;border-bottom:1px solid var(--border);border-right:1px solid var(--border);color:var(--txt2);max-width:280px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;vertical-align:middle}
.sq-table td:last-child{border-right:none}
.sq-table td.sq-null{color:var(--txt3);font-style:italic}
.sq-table td.sq-num{color:var(--brass);text-align:right}
.sq-table tr:hover td{background:var(--surface-2)}
.sq-table tr:nth-child(even) td{background:var(--surface2)}
.sq-table tr:nth-child(even):hover td{background:#F3F2EE}

/* DML success */
.sq-dml-result{padding:32px 24px;display:flex;flex-direction:column;align-items:center;gap:10px}
.sq-dml-icon{width:52px;height:52px;border-radius:50%;background:var(--valid-wash);display:flex;align-items:center;justify-content:center;font-size:24px;color:var(--valid)}
.sq-dml-msg{font-size:15px;font-weight:600;color:var(--navy)}
.sq-dml-sub{font-size:12px;color:var(--txt3)}

/* Error state */
.sq-error{padding:16px 20px;background:#F5E4E4;border-left:3px solid var(--red);margin:12px;border-radius:var(--r);font-family:var(--font-mono);font-size:12px;color:var(--error);white-space:pre-wrap;line-height:1.6}
.sq-error-label{font-size:10px;font-weight:700;color:var(--red);letter-spacing:.5px;text-transform:uppercase;margin-bottom:6px;font-family:var(--font-ui);display:flex;align-items:center;gap:5px}

/* Empty state */
.sq-empty{padding:40px 24px;display:flex;flex-direction:column;align-items:center;gap:8px;color:var(--txt3)}
.sq-empty i{font-size:36px}
.sq-empty span{font-size:13px;font-weight:500}

/* Spinner */
.sq-spinner{display:flex;align-items:center;gap:10px;padding:24px;color:var(--txt3);font-size:12px}
.spinner-sm{width:18px;height:18px;border:2px solid var(--border);border-top-color:var(--accent);border-radius:50%;animation:spin .7s linear infinite;flex-shrink:0}
@keyframes spin{to{transform:rotate(360deg)}}

@media(max-width:768px){.sq-sidebar{display:none}.sq-shortcut{display:none}}
`;

export const MARKUP = `
<div class="shell">
  <div class="sq-body">

    <!-- Sidebar: schema browser -->
    <div class="sq-sidebar">
      <div class="sq-sidebar-hdr">
        <i class="ti ti-database"></i>Schema Browser
        <button id="sq-refresh-schema" title="Refresh tables" style="margin-left:auto;background:none;border:none;cursor:pointer;color:var(--txt3);padding:0 2px;font-size:13px;line-height:1" onclick="sqRefreshSchema()">
          <i class="ti ti-refresh"></i>
        </button>
      </div>
      <div id="sq-tree" class="sq-tree">
        <div class="sq-schema-loading">Loading tables…</div>
      </div>
    </div>

    <!-- Main: toolbar + editor + results -->
    <div class="sq-main">

      <!-- Toolbar -->
      <div class="sq-toolbar">
        <div id="sq-type-badge" class="sq-badge sq-badge-select">SELECT</div>
        <button id="sq-run-btn" class="sq-btn sq-btn-run" onclick="sqRun()">
          <i class="ti ti-player-play-filled"></i>Run<span class="sq-shortcut">Ctrl+Enter</span>
        </button>
        <div class="sq-toolbar-sep"></div>
        <button class="sq-btn" onclick="sqClear()"><i class="ti ti-eraser"></i>Clear</button>
        <div id="sq-status" class="sq-status"></div>
        <button id="sq-csv-btn" class="sq-btn sq-btn-sm" style="display:none" onclick="sqExportCsv()">
          <i class="ti ti-download"></i>CSV
        </button>
      </div>

      <!-- Editor area -->
      <div class="sq-editor-area" id="sq-editor-area" style="height:var(--sq-editor-h,280px)">
        <div class="sq-gutter" id="sq-gutter"></div>
        <textarea
          id="sq-editor"
          class="sq-editor"
          spellcheck="false"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="off"
          placeholder="-- Write your SQL here&#10;-- Ctrl+Enter to run&#10;&#10;SELECT * FROM dashboard.campaign_metrics LIMIT 20;"
        ></textarea>
      </div>

      <!-- Resize handle -->
      <div class="sq-drag-handle" id="sq-drag-handle"></div>

      <!-- Results panel -->
      <div class="sq-results" id="sq-results-panel">
        <div class="sq-results-hdr">
          <div class="sq-results-info" id="sq-results-info">
            <i class="ti ti-table"></i>Results
          </div>
          <div class="sq-results-actions" id="sq-results-actions" style="display:none">
            <button class="sq-btn sq-btn-sm" onclick="sqExportCsv()"><i class="ti ti-download"></i>Export CSV</button>
          </div>
        </div>
        <div class="sq-results-body" id="sq-results-body">
          <div class="sq-empty">
            <i class="ti ti-terminal-2"></i>
            <span>Run a query to see results</span>
          </div>
        </div>
      </div>

    </div><!-- .sq-main -->
  </div><!-- .sq-body -->
</div><!-- .shell -->
`;


